import React, { useEffect, useState } from "react";
import { fetchData } from "../Components/common/utils";
import MainLoader from "../Components/MainLoader";
function FaqsPage() {
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [newDetail, setNewDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchApiData = async () => {
      setLoading(true)
      const url = "api/faqs/list";
      const result = await fetchData(url);

      if (result && result.data) {
        const categories = Array.from(
          new Set(
            result.data
              .map(item => item?.category?.title)
              .filter(Boolean)
          )
        );

        setCategoryList(categories);
        setNewDetail(result.data);

        // Set first category as default selected
        setLoading(false)
        if (categories.length > 0) {
          setSelectedCategory(categories[0]);
        }
      }
    };

    fetchApiData();
  }, []);

  // Filter FAQs by selected category
  const filteredFaqs = newDetail.filter(
    item => item?.category?.title === selectedCategory
  );

  return (
    <div>
      {loading && <MainLoader />}
        <div className="container">
          <div className="mt-4">
            {/* Modern Header */}
            <div className="brand-banner py-5 px-3 text-center text-white mb-4">
              <h1 className="display-4 fw-bold mb-2">Frequently <span className="brand-name">Asked</span> Questions</h1>
              <p className="lead">Find answers to common questions, explore helpful tips, and get the information you need quickly.</p>
            </div>
          </div>
        </div>

      <div className="container">
        {/* Category Buttons */}
        <div className="d-flex align-items-center justify-content-center gap-2 my-5 flex-wrap">
          {categoryList.map((category, index) => (
            <button
              key={index}
              className={`tabs-btns ${selectedCategory === category ? "active" : ""}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Accordion */}
        <div className="accordion mb-4" id="accordionExample">
          {filteredFaqs.length === 0 ? (
            <p className="text-center">No FAQs found for this category.</p>
          ) : (
            filteredFaqs.map((item, index) => (
              <div key={index} className="accordion-item">
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`collapse${index}`}
                  >
                    {item?.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {item?.answer}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default FaqsPage;
